import { StyleSheet } from 'react-native';

import { isIPhoneDeviceWithNotch } from '../../../Utils/Platform';
import { Fonts, Colors } from '../../Themes';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  containerStyle: {
    flex: 1,
  },
  imageContainerStyle: {
    flex: 1,
    position: 'absolute',
    bottom: 0,
    right: 0,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  textContainerStyle: {
    flex: 1,
    marginHorizontal: 15,
    marginTop: 100,
  },
  titleTextStyle: {
    fontSize: 28,
    ...Fonts.type.bold,
    color: Colors.white,
    marginBottom: 20,
  },
  descriptionTextStyle: {
    fontSize: 16,
    color: Colors.white,
    lineHeight: 22,
  },
  buttonStyle: {
    marginBottom: isIPhoneWithNotch ? 45 : 32,
    marginHorizontal: 16,
  },
});
